<template>
  <tr>
    <td class="product-header">
      <div class="product-and-subs-container">
        <span>{{ getProductName(item) }}</span>
        <clip-loader v-if="searching" :loading="searching" size="12px" color="#003340" />
        <div
          v-if="!hasSearchedSubs && !searching"
          class="search-subs-btn-container"
          @click="getSubselectionSales(item.productId)"
        >
          <span style="margin-right: 4px" class="search-subs-text">Υποεπιλογές</span>
          <font-awesome-icon icon="search" />
        </div>
        <div
          v-else-if="subOptionsStats.length>0 && !searching && hasSearchedSubs"
          class="subs-container"
        >
          <span
            :key="index"
            v-for="(subOptionStat, index) in subOptionsStats"
          >• {{subOptionStat.quantity}} {{getSubOptionName(subOptionStat)}} {{subOptionStat.totalPrice > 0 ? subOptionStat.totalPrice.toFixed(2)+'€' : ''}}</span>
        </div>
        <div
          v-else-if="subOptionsStats.length==0 && !searching && hasSearchedSubs"
          class="no-subs-container"
        >
          <span>Δεν έχει υποεπιλογές</span>
        </div>
      </div>
    </td>
    <td class="text-center">{{item.quantity}}</td>
    <td class="text-center">{{ item.totalPrice }}€</td>
    <td class="text-center">{{ getProductCategoryName(item) }}</td>
  </tr>
</template>

<script>
import StoreApi from "../api/stores";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

export default {
  name: "ProductStat",
  components: {
    ClipLoader
  },
  props: ["item", "selectedDepartmentId", "typeOfSales", "startingDate", "endingDate", "orderOrigin", "waiterToSearch", "selectedTableId"],
  mounted() {
  },
  computed: {

  },
  data() {
    return {
      hasSearchedSubs: false,
      searching: false,
      subOptionsStats: []
    }
  },
  methods: {

    getSubOptionName(subOptionStat) {
      let greName = subOptionStat.subselection.names.find(name => name.language == 'GRE');
      if (greName) {
        return greName.name;
      }
      return "Χωρίς όνομα";
    },

    getProductName(item) {
      return item.productName.translation.GRE
        ? item.productName.translation.GRE.name
        : item.productName.translation.ENG
          ? item.productName.translation.ENG.name
          : "";
    },

    getProductCategoryName(item) {
      return item.productCategory.categoryName.translation.GRE
        ? item.productCategory.categoryName.translation.GRE.name
        : item.productCategory.categoryName.translation.ENG
          ? item.productCategory.categoryName.translation.ENG.name
          : "";
    },

    formatDateForServer(date) {
      let yyyy = date.getFullYear();
      let MM = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      let dd = String(date.getDate()).padStart(2, '0');
      let HH = String(date.getHours()).padStart(2, '0');
      let mm = String(date.getMinutes()).padStart(2, '0');
      let ss = String(date.getSeconds()).padStart(2, '0');

      return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
    },

    async getSubselectionSales(productId) {
      this.searching = true;

      let startingDateForServer = this.formatDateForServer(this.startingDate);
      let endingDateForServer = this.formatDateForServer(this.endingDate);
      let selectedUserId = this.orderOrigin == 'CUSTOMER' ? null : this.waiterToSearch;

      let authToken = this.$store.getters.getUserAuthToken;
      let jwt = this.$store.getters.getUserJWT;
      let response = await StoreApi.getSubselectionSales(this.selectedDepartmentId, productId, this.typeOfSales, startingDateForServer, endingDateForServer, selectedUserId, this.selectedTableId, this.orderOrigin, authToken, jwt);

      this.hasSearchedSubs = true;
      this.subOptionsStats = response;

      this.searching = false;
    },
  },
};
</script>

<style scoped>
td {
  border: 1px solid #dddddd;
  padding: 8px;
  font-size: 14px;
}

.search-subs-btn-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #479df9d4;
  font-size: 13px;
  font-weight: 500;
  margin-top: 2px;
  user-select: none;
}

.search-subs-text {
  text-decoration: underline;
}

.product-and-subs-container {
  display: flex;
  flex-direction: column;
}

.subs-container {
  font-size: 13px;
  color: #575757;
  margin-left: 0px;
  display: flex;
  flex-direction: column;
}

.no-subs-container {
  font-size: 12px;
  font-weight: 500;
  color: #707070;
  font-style: italic;
  margin-left: 0px;
  margin-top: 4px;
}

.text-center {
  text-align: center;
}

.product-header {
  text-align: left;
  min-width: 150px !important;
  max-width: 170px;
}

@media screen and (max-width: 350px) {
  td {
    font-size: 13px;
  }

  .product-header {
    max-width: 145px;
  }
}

@media screen and (max-width: 285px) {
  td {
    font-size: 12px;
  }

  .product-header {
    max-width: 120px;
  }
}
</style>